import { getApi, postApi } from "../apiCall";

export const blockEmd = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/transaction/block/emd`;
  return postApi(url, payload);
};

export const getSingleCharge = (connectionId) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/${connectionId}`;
  return getApi(url);
};

export const getCharges = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/bilateral-contract/${id}`;
  return getApi(url);
};
